export default [
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        internalType: "string",
        name: "_pair_id",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_position_id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_margin",
        type: "uint256",
      },
    ],
    name: "AddMargin",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        internalType: "string",
        name: "_order_id",
        type: "string",
      },
    ],
    name: "CancelOrder",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        internalType: "string",
        name: "_pair_id",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_position_id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_base_quantity",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_full_close",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "_market_close",
        type: "bool",
      },
    ],
    name: "ClosePosition",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        internalType: "string",
        name: "_pair_id",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_direction",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_base_quantity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_leverage",
        type: "uint256",
      },
    ],
    name: "CreateOrder",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_source_port",
        type: "string",
      },
      {
        internalType: "string",
        name: "_source_channel",
        type: "string",
      },
      {
        internalType: "address",
        name: "_sender",
        type: "address",
      },
      {
        internalType: "string",
        name: "_receiver",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_timeout_height",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_timeout_timestamp",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_router",
        type: "string",
      },
      {
        internalType: "string",
        name: "_token_denom",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_token_amount",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_fee_denom",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_fee_amount",
        type: "uint256",
      },
    ],
    name: "IBCTransfer",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
];
